// Contenu des formations EDUCASER GROUP.
// Contenu repris fidèlement (programmes, prérequis, objectifs, modalités, durées,
// examens, certifications, débouchés, financements, informations réglementaires).

const FINANCEMENT =
  "Contactez nos équipes qui pourront vous établir un devis et vous accompagner dans l'optimisation de votre budget avec les différents types de financement auxquels vous pouvez prétendre.";

// Métadonnées officielles de la certification RNCP (TP ECSR et ses CCS).
export const RNCP_ECSR = {
  code: "RNCP41862",
  intitule: "TP Enseignant de la conduite et de la sécurité routière (ECSR)",
  niveau: "Niveau 5 (bac +2)",
  certificateur: "Ministère du Travail, du Plein emploi et de l'Insertion",
  enregistrement: "24/11/2022",
  echeance: "31/12/2027",
  lien: "https://www.francecompetences.fr/recherche/rncp/41862/",
};

export const QUALIOPI_DEFAULTS = {
  publicConcerne:
    "Tout public souhaitant se former ou se professionnaliser aux métiers du transport et de la conduite : salariés, demandeurs d'emploi et particuliers en reconversion, sous réserve des prérequis propres à chaque formation.",
  modalitesFormat:
    "Formation en présentiel dans nos centres, avec alternance d'apports théoriques et pratiques et accès à la plateforme e-learning E-formapro.",
  lieu:
    "Dans nos centres d'Île-de-France : Palaiseau, Noisy-le-Sec, Meaux, Choisy-le-Roi, Pontault-Combault, Roissy-en-France et Le Plessis-Belleville.",
  delaiAcces:
    "Une session peut être organisée sous 15 jours ouvrés après validation de votre dossier d'inscription et de financement, selon les places disponibles.",
  modalitesInscription:
    "Inscription via notre formulaire en ligne, par téléphone ou par e-mail. Un conseiller étudie votre dossier, vérifie vos prérequis et vous accompagne dans le montage du financement. Pièces à fournir : pièce d'identité, permis de conduire requis et justificatifs de financement.",
  moyensTechniques:
    "Salles de cours équipées, véhicules en double commande, camions et autobus, simulateurs de conduite haut de gamme, plateforme e-learning E-formapro, supports numériques et formateurs experts issus du secteur du transport.",
  accessibilite:
    "Nos formations peuvent être adaptées aux personnes en situation de handicap. Contactez notre référent handicap pour étudier ensemble les modalités d'accueil et d'aménagement.",
};

const IMG = {
  truck:
    "https://images.pexels.com/photos/20862827/pexels-photo-20862827.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  truck2:
    "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=1200&q=80",
  coach:
    "https://images.unsplash.com/photo-1772380043258-c768a6b09691?auto=format&fit=crop&w=1200&q=80",
  coach2:
    "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=1200&q=80",
  instructor:
    "https://images.pexels.com/photos/9518018/pexels-photo-9518018.jpeg?auto=compress&cs=tinysrgb&w=1200",
  classroom:
    "https://images.pexels.com/photos/8419511/pexels-photo-8419511.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const CATEGORIES = [
  {
    slug: "formations-enseignants",
    title: "Formations d'enseignants",
    baseline: "Titre professionnel ECSR et certificats complémentaires de spécialisation.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/wz36v1tt_pexels-ai25studioai-7144210.webp",
  },
  {
    slug: "transport-de-marchandises",
    title: "Transport de marchandises",
    baseline: "Permis, FIMO, FCO et titres professionnels pour le transport routier de marchandises.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/ibsacqph_pexels-emrecan-dora-576914516-18942492.webp",
  },
  {
    slug: "transport-de-voyageurs",
    title: "Transport de voyageurs",
    baseline: "Permis D, FIMO, FCO et titres professionnels pour le transport de personnes.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/p4gp1knb_pexels-amiel-joseph-labrador-3214234-12542132.webp",
  },
];

export const FORMATIONS = [
  // ================= TRANSPORT DE MARCHANDISES =================
  {
    slug: "permis-c",
    category: "transport-de-marchandises",
    title: "Permis C",
    resume: "Permis de conduire C pour le transport de marchandises.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/siy0sk27_camion.jpg",
    duree: "70 heures",
    certificationShort: "Permis de conduire C",
    tarif: "2 150 € sans code · 2 215 € avec code",
    description:
      "Formation de conduite pour professionnels. Permis de conduire C pour le transport de marchandises.",
    objectifs: [
      "Acquérir les connaissances de sécurité routière afin de passer l'examen du code de la route, réussir l'épreuve de l'interrogation orale et des questions écrites, et se préparer à l'examen du permis de conduire de la catégorie C.",
    ],
    prerequis:
      "Titulaire du permis B français ou reconnu par l'état français en cours de validité, avoir 21 ans minimum, être apte médicalement, être en règle avec les obligations de recensement, être résident en France depuis plus de six mois et avoir satisfait à l'épreuve de l'ETG avant l'entrée en stage pratique.",
    programme:
      "Formation en présentiel avec alternance d'apports théoriques et pratiques, accès à la plateforme d'E-learning E-formapro, remise d'une documentation complète, enseignement par des professionnels qualifiés.",
    modalites: "Après visite médicale et inscription en ligne à l'examen du Permis auprès de l'ANTS.",
    examen:
      "Évaluations en cours de formation, épreuve ETG si nécessaire, épreuve Hors Circulation et en Circulation avec un inspecteur du permis de conduire.",
    certification:
      "Code de la route ETG, Permis de conduire C, sans niveau spécifique, Code RNCP/RS : Non inscrit, Code Certif Info : 54660, Formacode : 31816.",
    debouches:
      "Conducteur(trice) routier(ère) de marchandises, Conducteur(trice) routier(ère) de matières dangereuses (avec formation complémentaire).",
    financement: FINANCEMENT,
    reglementaire: "Centre de formation certifié.",
  },
  {
    slug: "permis-ce",
    category: "transport-de-marchandises",
    title: "Permis CE",
    resume: "Permis de conduire CE pour le transport de marchandises.",
    image: IMG.truck2,
    duree: "105 à 140 heures",
    certificationShort: "Permis de conduire CE",
    tarif: "2 450 € sans code · 2 515 € avec code",
    description: "Permis de conduire CE pour le transport de marchandises.",
    objectifs: [
      "Acquérir les connaissances de sécurité routière permettant de se présenter à l'examen du code de la route, à l'interrogation orale et écrite, et à l'examen du permis de conduire de la catégorie CE.",
    ],
    prerequis:
      "Titulaire du permis C en cours de validité, 21 ans minimum sauf pour les titulaires d'un titre professionnel ou d'un diplôme de niveau IV ou V de conducteur routier de marchandises sur porteur, apte médicalement.",
    programme:
      "Formation en présentiel avec alternance d'apports théoriques et pratiques, simulateur haut de gamme, accès à la plateforme d'E-learning E-formapro, remise d'une documentation complète.",
    modalites: "Visite médicale, inscription en ligne à l'examen du Permis auprès de l'ANTS.",
    examen:
      "Evaluations en cours de formation, épreuve ETG si nécessaire, épreuve Hors Circulation et en Circulation avec un inspecteur du permis de conduire.",
    certification: "Code la route ETG et Permis de conduire CE si réussite à l'examen.",
    debouches:
      "Conducteur(trice) routier(ère) de marchandises, conducteur(trice) routier(ère) de matières dangereuses (avec formation complémentaire).",
    financement: FINANCEMENT,
    reglementaire:
      "Durée : 105 à 140 heures selon niveau à l'entrée en formation. Centre de formation certifié.",
  },
  {
    slug: "fco-marchandises",
    category: "transport-de-marchandises",
    title: "FCO Marchandises",
    resume: "Formation Continue Obligatoire — transport de marchandises.",
    image: IMG.truck,
    duree: "35 heures sur 5 jours consécutifs",
    certificationShort: "Renouvellement CQC",
    description:
      "Formation continue obligatoire (FCO) pour le transport de marchandises, habilitation pour la conduite de certains véhicules routiers affectés aux transports de marchandises.",
    objectifs: [
      "Se perfectionner à une conduite rationnelle axée sur les règles de sécurité et sur la réduction de l'incidence de la conduite sur l'environnement.",
      "Actualiser ses connaissances en matière de réglementation du transport ainsi que les règles relatives à la santé, la sécurité routière et environnementale, le service et la logistique.",
      "Améliorer ses pratiques dans ces domaines.",
    ],
    prerequis:
      "Titulaire des permis de conduire des catégories C ou CE en cours de validité ou des permis reconnus en équivalence conformément aux articles R 222-1, R 222-2 et R 222-3 du code de la route. Être en situation de régularité quant à la qualification initiale (FIMO, titre ou diplôme de conducteur du transport routier de marchandises).",
    programme:
      "Formation de 35 heures sur 5 jours consécutifs, avec un effectif de 8 à 16 participants maximum. Moyens et méthodes pédagogiques incluent le présentiel, alternance d'apports théoriques et pratiques, conduite sur véhicule en double commande et simulateur haut de gamme, tests, remise d'une documentation complète et ciblée, et formateur issu du secteur du transport de marchandises ayant minimum 3 ans d'expérience dans la conduite et/ou l'exploitation ou titulaires du TP ECSR mention groupe lourd.",
    modalites:
      "Présentiel, alternance d'apports théoriques et pratiques, conduite sur véhicule en double commande et simulateur haut de gamme, tests, remise d'une documentation complète et ciblée.",
    examen:
      "Livret de suivi de formation, évaluation en début de formation, évaluation pratique et théorique finale.",
    certification:
      "Test final d'auto-évaluation permettant le renouvellement de la Carte de Qualification de Conducteur (CQC). Code RS : 5769, Code Certif Info : 112764, Formacode : 31826. Cette formation est valable 5 ans et doit être renouvelée.",
    debouches: "Certificat de réalisation, attestation de fin de formation.",
    financement: FINANCEMENT,
    reglementaire: "Agrément régional délivré au centre de formation par la DREAL.",
  },
  {
    slug: "fimo-marchandises",
    category: "transport-de-marchandises",
    title: "FIMO Marchandises",
    resume: "Formation Initiale Minimale Obligatoire — transport de marchandises.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/wtc31vqu_pexels-farhan-najeer-644774196-28520996.webp",
    duree: "140 heures sur quatre semaines consécutives",
    certificationShort: "Carte de Qualification de Conducteur (CQC)",
    description:
      "Formation initiale minimale obligatoire pour la conduite de certains véhicules routiers affectés aux transports de marchandises.",
    objectifs: [
      "Posséder les compétences requises pour opérer un véhicule de transport de marchandises conformément aux normes professionnelles.",
      "Se perfectionner à une conduite rationnelle axée sur les règles de sécurité et sur la réduction de l'incidence de la conduite sur l'environnement.",
      "Appliquer et respecter les réglementations du transport ainsi que les règles relatives à la santé, la sécurité routière, la sécurité environnementale, le service et la logistique.",
    ],
    prerequis:
      "La FIMO Marchandises concerne toute personne conduisant des véhicules dont le Poids Total Autorisé en Charge (PTAC) dépasse 3.5 tonnes et qui n'est pas titulaire d'un diplôme professionnel de conducteur routier. Le candidat doit être âgé de 21 ans minimum et titulaire du permis de conduire de la catégorie C1, C1E, C ou CE en cours de validité ou d'un permis reconnu en équivalence.",
    programme:
      "140 heures sur quatre semaines consécutives. Formation en présentiel avec alternance d'apports théoriques, simulateur, travaux individuels et collectifs, formation sur véhicule double commande. Intégration d'un module écoconduite avec bilan individuel.",
    modalites:
      "Présentiel, avec des moyens pédagogiques variés incluant simulateur et travaux pratiques.",
    examen:
      "Evaluation pratique de la conduite professionnelle et évaluation théorique sous forme d'un QCM.",
    certification:
      "Sous réserve de réussite à l'examen, délivrance de la Carte de Qualification de Conducteur (CQC). Cette formation est valable 5 ans et doit être renouvelée.",
    financement: FINANCEMENT,
    reglementaire: "Agrément régional délivré au centre de formation par la DREAL.",
  },
  {
    slug: "tp-conducteur-marchandises-porteur",
    category: "transport-de-marchandises",
    title: "TP – Conducteur du transport Routier de Marchandises sur Porteur",
    resume: "Titre Professionnel CTRMP — conducteur routier de marchandises sur porteur.",
    image: IMG.truck2,
    duree: "434 heures dont 35 heures de session d'examen",
    certificationShort: "Titre professionnel — Diplôme de niveau 3 (CAP/BEP)",
    description:
      "Le Titre Professionnel CTRMP concerne toute personne souhaitant exercer la profession de conducteur routier de marchandises, que ce soit dans le cadre du transport public ou privé, et ce, sur un véhicule porteur.",
    objectifs: [
      "Réaliser en sécurité un transport routier national ou international de marchandises avec un véhicule du groupe lourd d'une masse maximale admissible supérieure à 3,5 tonnes, de façon autonome et optimisée dans le contexte commercial de l'entreprise",
      "Respecter et appliquer les réglementations des transports tout au long de l'activité",
      "Effectuer les contrôles obligatoires et de sécurité d'un véhicule de transport de marchandises du groupe lourd tout au long de l'activité.",
      "Prévenir les situations difficiles et appliquer les procédures en cas d'incident ou d'accident à l'arrêt comme en circulation.",
    ],
    prerequis:
      "Le candidat doit : Etre titulaire du permis B en cours de validité. Etre âgé d'au moins 18 ans. Savoir lire et écrire. Etre reconnu médicalement apte lors d'une visite médicale.",
    programme: "Entretien individuel. Tests de positionnement. Test de conduite.",
    modalites:
      "Présentiel. Alternance d'apports pratiques et théoriques alliant individualisation, activités en autonomie, études de cas, mises en situation professionnelles reconstituées. Remise d'une documentation complète et ciblée. Formateur issu du secteur du transport de marchandises ayant minimum 3 ans d'expérience dans la conduite et/ou l'exploitation ou titulaires du TP ECSR mention groupe lourd.",
    examen:
      "Suivi de formation via un livret de formation. Evaluation en cours de formation sous la forme de mises en situation, études de cas, quizz. Evaluations anticipée et finale par un jury professionnel et par l'Inspecteur du Permis de Conduire et de la Sécurité Routière.",
    certification:
      "Sous réserve de réussite à l'examen, obtention du Titre professionnel de conducteur de transport routier de marchandises sur porteur et délivrance de la Carte de Qualification de Conducteur (CQC). Certificat ADR (matières dangereuses). Diplôme de niveau 3 (CAP/BEP). Code RNCP : 39796. Code Certif Info : 103807.",
    financement: FINANCEMENT,
    reglementaire:
      "Agrément délivré au centre de formation par la DRIEETS pour la session d'examen.",
  },

  // ================= TRANSPORT DE VOYAGEURS =================
  {
    slug: "permis-d",
    category: "transport-de-voyageurs",
    title: "Permis D",
    resume: "Permis de conduire de catégorie D pour le transport de voyageurs.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/p4gp1knb_pexels-amiel-joseph-labrador-3214234-12542132.webp",
    duree: "70 heures",
    certificationShort: "Permis de conduire catégorie D",
    tarif: "2 150 € sans code · 2 215 € avec code",
    description:
      "Formation de conduite pour professionnels, axée sur le permis de conduire de catégorie D pour le transport de voyageurs.",
    objectifs: [
      "Acquérir les connaissances de sécurité routière afin de passer l'examen du code de la route, ainsi que les connaissances techniques, réglementaires, professionnelles et de sécurité routière pour l'examen du permis de conduire de la catégorie D.",
    ],
    prerequis:
      "Titulaire du permis B français ou reconnu par l'état français, avoir 24 ans minimum (sauf pour les candidats en formation professionnelle), savoir lire et écrire le français, être apte médicalement, être en règle avec les obligations de recensement, être résident en France depuis plus de six mois et avoir satisfait à l'épreuve de l'ETG.",
    programme:
      "Formation de 70 heures, incluant des apports théoriques, de la conduite et des mises en situations professionnelles, avec accès à une plateforme d'E-learning et remise d'une documentation complète.",
    modalites:
      "Présentiel sauf pour l'ETG et préparation à l'interrogation orale et écrite en e-learning.",
    examen:
      "Évaluations en cours de formation, épreuve ETG si nécessaire, épreuve Hors Circulation et épreuve en Circulation avec un inspecteur du permis de conduire.",
    certification:
      "Code la route ETG si réussite à l'examen, permis de conduire catégorie D si réussite à l'examen.",
    debouches:
      "Conducteur(trice) routier(ère) de personnes, avec possibilité d'obtenir la Qualification Professionnelle de Conducteur routier après une Formation Initiale Minimale Obligatoire (FIMO) et une Formation Continue Obligatoire (FCO) tous les 5 ans.",
    financement: FINANCEMENT,
    reglementaire: "Centre de formation certifié.",
  },
  {
    slug: "fco-voyageurs",
    category: "transport-de-voyageurs",
    title: "FCO Voyageurs",
    resume: "Formation Continue Obligatoire — transport de voyageurs.",
    image: IMG.coach2,
    duree: "35 heures sur 5 jours consécutifs",
    certificationShort: "Renouvellement CQC",
    description:
      "Formation continue obligatoire (FCO) pour le transport de voyageurs. Habilitation pour la conduite de certains véhicules routiers affectés aux transports de voyageurs.",
    objectifs: [
      "Se perfectionner à une conduite rationnelle axée sur les règles de sécurité et la réduction de l'incidence de la conduite sur l'environnement.",
      "Actualiser ses connaissances en matière de réglementation du transport ainsi que de santé, sécurité routière, sécurité environnementale, service et logistique.",
      "Améliorer ses pratiques dans ces domaines.",
    ],
    prerequis:
      "Titulaire des permis de conduire des catégories D, D1, D1E ou DE en cours de validité ou des permis reconnus en équivalence conformément aux articles R. 222-1, R. 222-2 et R. 222-3 du code de la route. Être en situation de régularité quant à la qualification initiale (FIMO, titre ou diplôme de conducteur du transport routier de personnes).",
    programme:
      "Formation de 35 heures sur 5 jours consécutifs, avec un effectif de 8 à 16 participants maximum. Moyens et méthodes pédagogiques incluent le présentiel, alternance d'apports théoriques et pratiques, conduite sur véhicule en double commande et simulateur haut de gamme, tests, remise d'une documentation complète et ciblée, et formateur issu du secteur du transport de voyageurs ayant minimum 3 ans d'expérience dans la conduite et/ou l'exploitation ou titulaires du TP ECSR mention groupe lourd.",
    modalites:
      "Présentiel avec alternance d'apports théoriques et pratiques, conduite sur véhicule en double commande et simulateur haut de gamme, tests, remise d'une documentation complète et ciblée.",
    examen:
      "Livret de suivi de formation, évaluation en début de formation, évaluation pratique et théorique finale.",
    certification:
      "Test final d'auto-évaluation permettant le renouvellement de la Carte de Qualification de Conducteur (CQC). Code RS : 5768, Code Certif Info : 112765, Formacode : 31826. Cette formation est valable 5 ans et doit être renouvelée.",
    debouches:
      "Certificat de réalisation et attestation de fin de formation remis à l'issue de la formation.",
    financement: FINANCEMENT,
    reglementaire: "Agrément régional délivré au centre de formation par la DREAL.",
  },
  {
    slug: "fimo-voyageurs",
    category: "transport-de-voyageurs",
    title: "FIMO Voyageurs",
    resume: "Formation Initiale Minimale Obligatoire — transport de voyageurs.",
    image: IMG.coach,
    duree: "140 heures sur quatre semaines consécutives",
    certificationShort: "Carte de Qualification de Conducteur (CQC)",
    description:
      "Formation initiale minimale obligatoire (FIMO) pour le transport de voyageurs. Habilitation pour la conduite de certains véhicules routiers affectés aux transports de voyageurs.",
    objectifs: [
      "Posséder les compétences requises pour opérer un véhicule de transport de voyageurs conformément aux normes professionnelles.",
      "Se perfectionner à une conduite rationnelle axée sur les règles de sécurité et sur la réduction de l'incidence de la conduite sur l'environnement.",
      "Appliquer et respecter les réglementations du transport ainsi que les règles relatives à la santé, la sécurité routière, la sécurité environnementale, le service et la logistique.",
    ],
    prerequis:
      "La FIMO Voyageurs concerne toute personne conduisant un véhicule de plus de 9 places, incluant le conducteur, et n'étant pas en possession d'un diplôme professionnel de conducteur de transport en commun. Le candidat doit être âgé de 21 ans minimum et titulaire du permis de conduire de la catégorie D, D1E, D ou DE en cours de validité ou d'un permis reconnu en équivalence.",
    programme:
      "Formation de 140 heures sur quatre semaines consécutives, avec un effectif de 8 à 16 participants maximum. Moyens pédagogiques incluent des apports théoriques, simulateur, travaux individuels et collectifs, formation sur véhicule double commande, et remise d'une documentation complète.",
    modalites:
      "Présentiel avec alternance d'apports théoriques, simulateur, travaux individuels et collectifs, formation sur véhicule double commande.",
    examen:
      "Evaluation finale avec un livret de suivi de formation, évaluation pratique de la conduite professionnelle, et évaluation théorique sous forme d'un QCM.",
    certification:
      "Sous réserve de réussite à l'examen, délivrance de la Carte de Qualification de Conducteur (CQC). Cette formation est valable 5 ans et doit être renouvelée.",
    debouches:
      "Possibilité d'opérer en tant que conducteur de transport de voyageurs dans le secteur public ou privé.",
    financement: FINANCEMENT,
    reglementaire: "Agrément régional délivré au centre de formation par la DREAL.",
  },
  {
    slug: "tp-conducteur-transport-commun-route",
    category: "transport-de-voyageurs",
    title: "TP – Conducteur de transport en commun sur route",
    resume: "Titre Professionnel CTCR — conducteur de transport en commun sur route.",
    image: IMG.coach,
    duree: "434 heures dont 35 heures de session d'examen",
    certificationShort: "Titre professionnel — Diplôme de niveau 3 (CAP/BEP)",
    description:
      "Le Titre Professionnel CTCR forme des conducteurs de transport en commun routier, leur permettant d'obtenir le permis de conduire de catégorie D. Une fois diplômé, le conducteur sera qualifié pour exercer en tant que chauffeur d'autobus, d'autocar ou de bus scolaire.",
    objectifs: [
      "Réaliser en sécurité un transport de personnes à l'aide d'un véhicule de transport en commun",
      "Appliquer les consignes d'exploitation et effectuer les contrôles de sécurité dans le cadre d'un transport en commun",
      "Prévenir les risques, mettre en œuvre ou appliquer les procédures en cas de situation difficile, incident ou accident dans le cadre d'un transport en commun",
    ],
    prerequis:
      "Le candidat doit être : Titulaire du permis B. Agé d'au moins 21 ans. Agé d'au moins 18 ou 20 ans sous conditions restrictive. Reconnu médicalement apte lors d'une visite médicale.",
    programme:
      "Présentiel. Alternance d'apports pratiques et théoriques alliant individualisation, activités en autonomie, études de cas, mises en situation professionnelles reconstituées. Remise d'une documentation complète et ciblée. Formateur issu du secteur du transport de voyageurs ayant minimum 3 ans d'expérience dans la conduite et/ou l'exploitation ou titulaires du TP ECSR mention groupe lourd.",
    modalites:
      "Suivi de formation via un livret de formation. Evaluation en cours de formation sous la forme de mises en situation, études de cas, quizz. Evaluations anticipée et finale par un jury professionnel et par l'Inspecteur du Permis de Conduire et de la Sécurité Routière.",
    examen:
      "Sous réserve de réussite à l'examen, obtention du Titre professionnel de conducteur de transport en commun et délivrance de la Carte de Qualification de Conducteur (CQC). Attestation en Sauvetage Secourisme du Travail (SST). Attestation de formation à la manipulation du matériel de lutte contre les incendies. Diplôme de niveau 3 (CAP/BEP). Code RNCP : 37878. Code Certif Info : 100817.",
    certification:
      "Diplôme de niveau 3 (CAP/BEP). Code RNCP : 37878. Code Certif Info : 100817.",
    debouches:
      "Le conducteur sera qualifié pour exercer en tant que chauffeur d'autobus, d'autocar ou de bus scolaire.",
    financement: FINANCEMENT,
    reglementaire:
      "Les personnes en situation de handicap peuvent avoir des besoins spécifiques pour suivre la formation, n'hésitez pas à nous contacter pour en discuter.",
  },

  // ================= FORMATIONS D'ENSEIGNANTS =================
  {
    slug: "tp-ecsr",
    category: "formations-enseignants",
    title: "TP – Enseignant de la Conduite et de la Sécurité Routière",
    resume: "Titre Professionnel ECSR — autorisation d'enseigner catégorie B.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/wz36v1tt_pexels-ai25studioai-7144210.webp",
    duree: "910 heures de formation + 280 heures de stage",
    certificationShort: "Titre Professionnel ECSR — Diplôme de niveau 5 (bac +2)",
    description:
      "Le Titre Professionnel ECSR permet d'obtenir l'autorisation d'enseigner pour les formations de la catégorie B.",
    objectifs: [
      "Préparer et animer des actions de formation « tous publics » et contribuer à la mise en œuvre de la politique de sécurité routière",
      "Former des apprenants conducteurs par des actions individuelles et collectives dans le cadre des réglementations en vigueur",
      "Sensibiliser l'ensemble des usagers de la route à l'adoption de comportements sûrs et respectueux de l'environnement",
    ],
    prerequis:
      "Le candidat doit : Etre titulaire du permis de conduire de catégorie B dont le délai probatoire a expiré. Avoir certificat médical en cours de validité attestant que les conditions d'aptitude physique mentionnée à l'article R.212-2 du code de la route sont remplies. Détenir un niveau de culture générale BAC (obtenu ou non). Avoir un casier judiciaire vierge.",
    programme: "910 heures de formation + 280 heures de stage.",
    modalites:
      "Parcours mixte continu. Alternance d'apports pratiques et théoriques alliant individualisation, activités en autonomie, ateliers collectifs et mise en application en entreprise. Remise d'une mallette pédagogique. Enseignants titulaires du TP FMESR ou du BAFM.",
    examen:
      "Evaluations tout au long de la formation sous la forme de mises en situation, études de cas, quizz, examens blancs. Validation des compétences par un examen final devant un jury de professionnels comprenant une mise en situation professionnelle, un entretien technique, un questionnement à partir de productions et un entretien final.",
    certification:
      "Titre Professionnel d'Enseignant de la Conduite et de la Sécurité Routière (ECSR). Diplôme de niveau 5 (bac +2). Code RNCP : 41862. Code Certif Info : 110499.",
    debouches:
      "Après l'obtention de votre TP ECSR, des certificats complémentaires de spécialisation peuvent être réalisés. Ils permettent de devenir enseignant de la conduite pour les deux-roues (CCS deux-roues) ainsi que pour les poids lourds (CCS groupe lourd). Après 1607 heures d'expérience professionnelle en tant qu'enseignant de la conduite, vous pourrez suivre une formation délivrant le Titre professionnel de Formateur aux Métiers de l'Education et de la Sécurité Routières (FMESR) et ainsi assurer la formation aux métiers de l'enseignement de la conduite et de la sécurité routière en formation initiale et continue.",
    financement: FINANCEMENT,
    reglementaire:
      "Agrément délivré au centre de formation par la DRIEETS pour la session d'examen.",
  },
  {
    slug: "ccs-2-roues",
    category: "formations-enseignants",
    title: "CCS – 2 ROUES du TP Enseignant de la Conduite et de la Sécurité Routière",
    resume: "Certificat Complémentaire de Spécialisation deux-roues.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/mww4101w_IMGP5819-e1454583361109-1024x681.jpg",
    duree: "210 heures",
    certificationShort: "CCS 2 roues — Diplôme de niveau 5 (bac +2)",
    description:
      "Le Certificat Complémentaire de Spécialisation (CCS) deux roues permet de devenir enseignant de la conduite automobile et de la sécurité routière pour des véhicules deux roues motorisés.",
    objectifs: [
      "Animer des actions de formation individuelles ou collectives à la conduite d'un véhicule deux roues motorisé en et hors circulation.",
      "Enseigner les spécificités liées à la conduite des véhicules deux roues motorisés et à leur contexte d'utilisation.",
      "Faire respecter le code de la route, la réglementation, la sécurité routière et faire adopter des comportements sécuritaires.",
    ],
    prerequis:
      "Titulaire du titre professionnel ECSR. Titulaire du permis A en cours de validité et ne plus être en période probatoire. Être apte médicalement.",
    programme:
      "Le programme inclut un parcours mixte continu, alternance d'apports pratiques et théoriques, mises en situation professionnelle, et remise d'une documentation complète.",
    modalites: "Après un test de positionnement.",
    examen:
      "Validation des compétences par un examen final devant un jury professionnel comprenant une mise en situation professionnelle, un entretien technique et un entretien final.",
    certification:
      "Certificat Complémentaire de Spécialisation 2 roues du Titre Professionnel d'Enseignant de la Conduite et de la Sécurité Routière (ECSR). Diplôme de niveau 5 (bac +2). Code RNCP : 41862. Code Certif Info : 110499.",
    debouches:
      "Les débouchés incluent des postes d'enseignant de la conduite pour véhicules deux roues motorisés.",
    financement: FINANCEMENT,
    reglementaire:
      "Agrément délivré au centre de formation par la DRIEETS pour la session d'examen.",
  },
  {
    slug: "ccs-groupe-lourd",
    category: "formations-enseignants",
    title: "CCS – GROUPE LOURD du TP Enseignant de la Conduite et de la Sécurité Routière",
    resume: "Certificat Complémentaire de Spécialisation groupe lourd.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/ocsam9fc_200c8b32d152.webp",
    duree: "245 heures",
    certificationShort: "CCS groupe lourd — Diplôme de niveau 5 (bac +2)",
    description:
      "Le Certificat Complémentaire de Spécialisation (CCS) groupe lourd permet de devenir enseignant de la conduite automobile et de la sécurité routière mention groupe lourd.",
    objectifs: [
      "Animer des actions de formation individuelles ou collectives à la conduite d'un véhicule du groupe lourd en et hors circulation",
      "Enseigner les spécificités liées à la conduite des véhicules du groupe lourd et à leur contexte d'utilisation",
      "Animer des actions de prévention routière concernant la sécurité des poids lourds",
      "Mener des actions de perfectionnement des usagers de poids lourds",
    ],
    prerequis:
      "Le candidat doit être : Titulaire du titre professionnel ECSR. Titulaire de l'ensemble des permis de conduire du groupe lourd - C, CE et D - en cours de validité et ne plus être en période probatoire. Être apte médicalement.",
    programme:
      "Parcours mixte continu. Alternance d'apports pratiques et théoriques alliant individualisation, activités en autonomie et ateliers collectifs. Mises en situation professionnelle sur étude de cas pédagogique. Remise d'une documentation complète et ciblée. Simulateur haut de gamme, conduite sur véhicule double commande. Enseignants titulaires du TP FMESR ou du BAFM mention groupe lourd.",
    modalites: "Après un test de positionnement.",
    examen:
      "Suivi de formation via un livret de formation attestant de l'assiduité du candidat. Evaluations formatives et sommatives tout au long de la formation. Validation des compétences par un examen final devant un jury professionnel comprenant une mise en situation professionnelle, un entretien technique et un entretien final.",
    certification:
      "Certificat Complémentaire de Spécialisation groupe lourd du Titre Professionnel d'Enseignant de la Conduite et de la Sécurité Routière (ECSR). Diplôme de niveau 5 (bac +2). Code RNCP : 41862. Code Certif Info : 110499.",
    debouches: "Enseignant de la conduite et de la sécurité routière pour le groupe lourd.",
    financement: FINANCEMENT,
    reglementaire:
      "Agrément délivré au centre de formation par la DRIEETS pour la session d'examen.",
  },
];

export const getCategory = (slug) => CATEGORIES.find((c) => c.slug === slug);
export const getFormationsByCategory = (slug) =>
  FORMATIONS.filter((f) => f.category === slug);
export const getFormation = (slug) => FORMATIONS.find((f) => f.slug === slug);
